import React, { useEffect, useState } from 'react'
import ModalCustom from '../../../modal-custom'
import { cancelChecklistNewAPI } from '../../../../services/checklist'
import SwalCustom from '../../../../alert/swal-custom'
import Error_false from '../../../error/error-false'
import Error_500 from '../../../error/error-500'
import { TXTSUCCESS } from '../../../../Constants'
import { Button, Col, Form, Row } from 'react-bootstrap'
import { Controller, useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'
import Autocomplete from '../../../custom/autocomplete'
import LabelCustom from '../../../label-custom'
import moment from 'moment'
import DatepickerCustom from '../../../datepicker-custom'

const schema = yup
  .object({
    comment: yup.string().required('โปรดระบุข้อมูล'),
    type: yup.object().required('โปรดระบุข้อมูล'),
    endDate: yup.string().required('โปรดระบุข้อมูล')
  })
  .required()
export default function ModalCancel({
  open,
  onCancel,
  data,
  resignsOption,
  fnData,
  bodyFilter
}) {
  const [isSave, setIsSave] = useState(false)
  const {
    reset,
    control,
    setValue,
    setError,
    getValues,
    handleSubmit,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(schema)
  })
  useEffect(() => {
    resignsOption.length > 7 && setValue('type', resignsOption[7])

    if (data) {
      setValue('comment', '')
    }
  }, [resignsOption, setValue, data])

  useEffect(() => {
    if (data) {
      setValue('endDate', moment().format('YYYY-MM-DD'))
    }
  }, [data, setValue])

  const onSubmit = async (d) => {
    try {
      setIsSave(true)
      const body = {
        resign: d.type.label,
        cancelDescription: d.comment,
        clnNo: data?.cln_no,
        endDate: d?.endDate
      }
      const resp = await cancelChecklistNewAPI(body)
      setIsSave(false)
      if (!resp) return
      if (resp.status) {
        SwalCustom({
          title: `Success!`,
          text: TXTSUCCESS,
          timer: 1500,
          showConfirmButton: false
        }).then(() => {
          onCancel()
          fnData(bodyFilter)
          reset()
        })
      } else {
        Error_false(resp)
      }
    } catch (error) {
      Error_500(error)
    }
  }

  return (
    <ModalCustom open={open} onCancel={onCancel}>
      {isSave && <div className="preloader"></div>}

      <h5 className="text-danger">ยกเลิกรายการ</h5>
      <span>เลขที่: {data?.cln_no}</span>
      <Row className="mt-3">
        <Col xl={6}>
          <LabelCustom text="รหัสพนักงาน" />
          <p>{data?.code}</p>
        </Col>
        <Col xl={6}>
          <LabelCustom text="วันที่เริ่มงาน	" />
          <p>{moment(data?.start_date).format('DD MMM YYYY')}</p>
        </Col>
        <Col xl={6}>
          <LabelCustom text="	ชื่อ-นามสกุล	" />
          <p>
            {data?.name_th} {data?.surname_th}
          </p>
        </Col>
        <Col xl={6}>
          <LabelCustom text="	ตำแหน่ง" />
          <p>{data?.position_th}</p>
        </Col>
      </Row>
      <Form onSubmit={handleSubmit(onSubmit)}>
        <Row>
          <Col xl={12}>
            <LabelCustom text="เลือกสาเหตุ" />
            <Controller
              control={control}
              rules={{
                required: true
              }}
              render={({ field: { onChange, value } }) => (
                <Autocomplete
                  className="w-100"
                  options={resignsOption}
                  value={value}
                  onChange={onChange}
                  disabled={true}
                />
              )}
              name="type"
            />

            {errors.type && (
              <label className="small text-danger">{errors.type.message}</label>
            )}
          </Col>

          <Col xl={12} className="mt-2">
            <LabelCustom text="วันพ้นสภาพ" />
            <Controller
              control={control}
              rules={{
                required: true
              }}
              render={({ field: { onChange, value } }) => (
                <DatepickerCustom
                  className="w-100"
                  value={value}
                  onChange={([date]) => {
                    setValue(
                      'endDate',
                      date ? moment(date).format('YYYY-MM-DD') : ''
                    )
                    setError('endDate', date)
                  }}
                />
              )}
              name="endDate"
            />

            {errors.endDate && (
              <label className="small text-danger">
                {errors.endDate.message}
              </label>
            )}
          </Col>

          <Col xl={12} className="mt-1">
            <LabelCustom text="รายละเอียด" />
            <Controller
              control={control}
              rules={{
                required: true
              }}
              render={({ field: { onChange, value } }) => (
                <Form.Control
                  as="textarea"
                  rows={3}
                  value={value}
                  onChange={onChange}
                />
              )}
              name="comment"
            />
            {errors.comment && (
              <label className="small text-danger">
                {errors.comment.message}
              </label>
            )}
          </Col>
        </Row>

        <Row>
          <Col xl={12} className="text-end mt-4">
            <Button type="button" variant="secondary" onClick={onCancel}>
              ปิด
            </Button>
            <Button type="submit" disabled={isSave} className="px-4 ms-2">
              {isSave ? 'กำลังบันทึก...' : 'บันทึก'}
            </Button>
          </Col>
        </Row>
      </Form>
    </ModalCustom>
  )
}
